export const fetchAPI = async (url, methodType, body = null) => {
  try {
    const response = await fetch(url, {
      method: methodType,
      headers: { "Content-Type": "application/json" },
      ...(methodType !== "GET" && body && { body: JSON.stringify(body) }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error("API Fetch Error:", error);
    throw error;
  }
};
